import { Cancel } from "@mui/icons-material";
import { IconButton, InputAdornment, SxProps, TextField, Theme } from "@mui/material";

type Props = {
    label: string;
    value: string;
    onChange: (value: string) => void;
    sx?: SxProps<Theme>;
    size?: "small" | "medium";
};

export default function SearchInput({ label, value, onChange, sx, size = "small" }: Props) {
    return (
        <TextField
            label={label}
            variant="outlined"
            size={size}
            value={value}
            onChange={e => onChange(e.target.value)}
            sx={sx}
            slotProps={{
                input: {
                    endAdornment: value && (
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={() => onChange("")} edge="end">
                                <Cancel />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
}
